<template>
  <v-form ref="form" v-model="valid" lazy-validation class="catalogo-form">
    <v-row align="center" class="catalogo-row">
      <v-card class="catalogo-card">
        <v-row>
          <v-col cols="6">
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Pesquisar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-data-table
          v-if="tableOptions.itemsPerPage !== -1"
          :headers="headers"
              :items="filteredList"
              :loading="loading"
              loading-text="Buscando dados..."
              class="elevation-1 w-100"
              style="width: 100%"
          :options.sync="tableOptions"
          :footer-props="{
                showFirstLastPage: true,
                itemsPerPageText: 'Items por página',
                itemsPerPageOptions: [5, 10, 15, 50, 100, -1],
              }"
            >
              <template v-slot:item.codigo="{ item }">
                {{
                  item.codigo === null || item.codigo === ""
                    ? "NA"
                    : item.codigo
                }}
              </template>
          <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="info"
                      fab
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="addProduto(item)"
                      class="white--text"
                    >
                      <v-icon> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar serviço</span>
                </v-tooltip>
              </template>
            </v-data-table>
                      <catalogo-virtual-table
              v-else
              :headers="headers"
              :items="filteredList"
              :loading="loading"
              :items-per-page.sync="tableOptions.itemsPerPage"
              item-key="id"
            >
              <template v-slot:item.descricao="{ item }">
                <span class="catalogo-descricao" :title="item.descricao">
                  {{ item.descricao }}
                </span>
              </template>
              <template v-slot:item.codigo="{ item }">
                {{ item.codigo === null || item.codigo === "" ? "NA" : item.codigo }}
              </template>
          <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="info"
                      fab
                      small
                      v-bind="attrs"
                      v-on="on"
                      @click="addProduto(item)"
                      class="white--text"
                    >
                      <v-icon> mdi-plus </v-icon>
                    </v-btn>
                  </template>
                  <span>Adicionar servico</span>
                </v-tooltip>
              </template>
            </catalogo-virtual-table>
          </v-col>
        </v-row>
      </v-card>
    </v-row>
    <v-snackbar v-model="errorMessage" color="error" timeout="3000"
      >Informe a quantidade!
    </v-snackbar>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
import CatalogoVirtualTable from "../../Shared/CatalogoVirtualTable.vue";

export default {
  name: "produto",
  components: {
    CatalogoVirtualTable,
  },
  data: () => ({
    search: "",
    valid: true,
    errorMessage: false,
    tableOptions: {
      itemsPerPage: 10,
    },
    headers: [
      { text: "Id", value: "id", sortable: true, width: "100px" },
      { text: "Item", value: "descricao", sortable: true, width: "100%" },
      { text: "Cod. Fabricante", value: "codigo", sortable: true, width: "100%" },
      { text: "Und.", value: "unidadeMedida", sortable: true, width: "100%" },
      { text: "", value: "actions", sortable: false, width: "80px" },
    ],
  }),
  props: {
    servicosL: Array,
    showModal: Boolean,
  },
  computed: {
    ...mapGetters("produto", { listaServicosInterno: "servicosInternos" }),
    filteredList() {
      return this.listaServicosInterno.filter((p) => {
        return (
          (p.id.toString().toLowerCase().includes(this.search.toLowerCase()) ||
            (p.descricao || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (p.departamento || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (p.grupo || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (p.subGrupo || "").toLowerCase().includes(this.search.toLowerCase()) ||
            (p.marca|| "").toLowerCase().includes(this.search.toLowerCase())) &&
          p.ativo === true
        );
      });
    },
    loading() {
      return !(this.listaServicosInterno != null && this.listaServicosInterno.length > 0);
    },
  },
  methods: {
    updateObjectEstate() {
      return this.$refs.form.validate();
    },

    clear() {
      this.$refs.form.reset();
      this.$refs.form.resetValidation();
    },

    addProduto: function (p) {
      var produto = new Object();
      produto.idProduto = p.id;
      produto.descricao = p.descricao;
      produto.codigo = p.codigo;
      produto.unidadeMedida = p.unidadeMedida;
      produto.detalhe = null;
      produto.execucao = 0;
      produto.executado = false;
      produto.solicitante = null;
      produto.editingExecucao = false;
      produto.index =
        this.servicosL.length === 0
          ? 0
          : this.servicosL[this.servicosL.length - 1].index + 1;

      this.servicosL.push(JSON.parse(JSON.stringify(produto)));
    },
  },
};
</script>

<style scoped>
.catalogo-form,
.catalogo-row,
.catalogo-card {
  box-sizing: border-box;
  max-width: 100%;
  min-width: 0;
  width: 100%;
}

.catalogo-card {
  align-self: stretch;
  flex: 1 1 auto;
}

.catalogo-descricao {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-height: 1.35;
  overflow: hidden;
  overflow-wrap: anywhere;
  white-space: normal;
  word-break: normal;
}
</style>
